(function(d) {
  if ((d.location.search.indexOf('toggle=smart-nav') === -1) && (d.cookie.indexOf('toggle-smart-nav=1') === -1)) {
    return;
  }

  d.cookie = 'toggle-smart-nav=1; path=/';

  var subjectsList = [{"id":7000741,"description":"Art and design","slug":"art-and-design"},{"id":7001191,"description":"Business and finance","slug":"business-and-finance"},{"id":7000745,"description":"Citizenship","slug":"citizenship"},{"id":7001123,"description":"Classics","slug":"classics"},{"id":7000865,"description":"Computing","slug":"computing"},{"id":7000751,"description":"Design, engineering and technology","slug":"design-engineering-and-technology"},{"id":7000757,"description":"Drama","slug":"drama"},{"id":7001202,"description":"Economics","slug":"economics"},{"id":7000756,"description":"English","slug":"english"},{"id":7000792,"description":"Geography","slug":"geography"},{"id":7001265,"description":"Government and politics","slug":"government-and-politics"},{"id":7000849,"description":"History","slug":"history"},{"id":7100000,"description":"Languages","slug":"languages", "childSubjectIds": [3000766, 8000938, 7000822], "childSubjectDescriptions": ["French", "Spanish", "German"]},{"id":7001264,"description":"Law and legal studies","slug":"law-and-legal-studies"},{"id":7000896,"description":"Mathematics","slug":"mathematics"},{"id":7001228,"description":"Media studies","slug":"media-studies"},{"id":7000912,"description":"Music","slug":"music"},{"id":7001234,"description":"Pedagogy and professional development","slug":"pedagogy-and-professional-development"},{"id":7000724,"description":"Personal, social and health education","slug":"personal-social-and-health-education"},{"id":7000484,"description":"Philosophy and ethics","slug":"philosophy-and-ethics"},{"id":7000917,"description":"Physical education","slug":"physical-education"},{"id":7001235,"description":"Psychology","slug":"psychology"},{"id":7000926,"description":"Religious education","slug":"religious-education"},{"id":2000028,"description":"Science","slug":"science", "childSubjectIds": [2000029, 2000030, 2000031, 1001141], "childSubjectDescriptions": ["Biology", "Chemistry", "Physics"]},{"id":7001242,"description":"Sociology","slug":"sociology"},{"id":7001122,"description":"Student careers advice","slug":"student-careers-advice"},{"id":7000652,"description":"Vocational studies","slug":"vocational-studies"},{"id":7001341,"description":"Whole school","slug":"whole-school"}];

  var markup = '<style>.smart-nav{color:#222;font-size:15px}.smart-nav__intro{color:#999}.smart-nav__sentence{font-weight:700;line-height:1.5em;padding-bottom:10px;border-bottom:1px solid #ddd;margin-bottom:25px}.smart-nav__select{color:#5161c9;padding:0;margin-right:5px;border:0;border-bottom:3px solid #5161c9;-webkit-appearance:none;appearance:none;background-color:transparent;font-size:inherit;font-family:Effra;font-weight:700}.smart-nav__select-icon{height:.45em}.smart-nav__refine-search{color:#222;font-size:18px;text-decoration:none}.smart-nav__options-panel{display:none;position:fixed;top:0;left:0;right:0;bottom:0;z-index:9999;overflow-y:scroll;background-color:rgba(255,255,255,1);padding:20px;text-align:center}.smart-nav__options-panel.active{display:block}.smart-nav__option{display:block;padding-top:15px;padding-bottom:15px;text-decoration:none;color:#222;font-size:7vw;display:block}</style><div class="bg-pale-blue padding-md smart-nav"><div class="heading heading--xxl smart-nav__sentence">I want to find more <button class=smart-nav__select type=button>{{currentSubject}}<i class="icon-blue icon-chevron-rounded-down margin-left-xs smart-nav__select-icon"></i></button> resources</div><div class=margin-bottom-sm><a class=smart-nav__refine-search href="https://www.tes.com/resources/search/?subjects=GB%7C0%7C{{currentSubjectEncoded}}%7C">Search for more {{currentSubject}} resources</a></div><div class=smart-nav__options-panel><div class=smart-nav__options-list>{{options}}</div></div></div>';

  function toggleSmartNavOptions(evt, forceClose) {
    var panel = d.querySelector('.smart-nav__options-panel');
    if (panel) {
      var fn = panel.classList.contains('active') || forceClose ? 'remove' : 'add';
      panel.classList[fn]('active');
    }
  }

  function getTopLevelSubjectFromSubjects(subjects) {
    try {
      var found = '';
      var idx = 0;
      while(!found) {
        var subject = subjects[idx];
        var fqn = subject.fqn.split('|');
        if (fqn[1] === '0') {
          found = subject.description;
        }
        if (subject.country === 'GB') {
          found = fqn[2];
        }
      }
      return found;
    } catch (err) {
      return '';
    }
  }

  function getTopLevelSubject() {
    var script = d.querySelector('script[data-iso-key]');
    if (script) { // rdp
      try {
        var json = script.innerHTML;
        json = JSON.parse(json);
        var resource = json.resource || {};
        return resource.primaryCategory || getTopLevelSubjectFromSubjects(resource.subjects);
      } catch (err) {
        return '';
      }
    }
    try {
      var subject = d.location.pathname.match(/\/teaching-resources\/hub\/secondary\/([^\/]*)/);
      if (subject && subject.length) { // hub
        return subject[1];
      }
    } catch (err) {
      return '';
    }
  }

  function createSubjectOptions(currentSubject) {
    var options = '';
    var currentSubjectName = '';
    subjectsList.forEach(function(subject) {
      var selected = '';
      if (
        (subject.id === currentSubject)
        || (subject.description === currentSubject)
        || (subject.slug === currentSubject)
        || (subject.childSubjectIds && subject.childSubjectIds.indexOf(currentSubject) > -1)
        || (subject.childSubjectDescriptions && subject.childSubjectDescriptions.indexOf(currentSubject) > -1)
      ) {
        selected = ' selected';
        currentSubjectName = subject.description;
      }
      options += '<a class=smart-nav__option href=https://www.tes.com/teaching-resources/hub/secondary/' + subject.slug + ' data-resource-id="' + subject.id + '" ' + selected + '>' + subject.description + '</a>';
    });
    return {
      options: options,
      currentSubject: currentSubjectName
    };
  }

  var sibling = d.querySelector('body>.l-container,body>.main-container,body>.js-app');
  if (sibling && sibling.parentNode) {
    var parent = sibling.parentNode;
    var currentSubject = getTopLevelSubject();
    var subjectOptions = createSubjectOptions(currentSubject);
    if (currentSubject && subjectOptions.currentSubject) {
      markup = markup.replace('{{options}}', subjectOptions.options);
      markup = markup.replace(/\{\{currentSubject\}\}/g, subjectOptions.currentSubject);
      markup = markup.replace('{{currentSubjectEncoded}}', encodeURIComponent(subjectOptions.currentSubject));
      var newNode = document.createElement('div');
      newNode.innerHTML = markup;
      var insertedNode = parent.insertBefore(newNode, sibling);
      var select = insertedNode.querySelector('.smart-nav__select');
      select && select.addEventListener('click', toggleSmartNavOptions, true);
      window.addEventListener('keyup', function (e) {
        if (e.keyCode === 27) {
          toggleSmartNavOptions(e, true);
        }
      });
    }
  }

}(document));
